exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section-question h3 {\n  color: #0669f9;\n  font-weight: bold;\n}\n.section-question p {\n  color: #1b1b1b;\n  font-size: 1em;\n  font-weight: 500;\n  padding-top: 10px;\n}\n.section-question b {\n  color: #000;\n}\n.section-question a {\n  color: #0669f9;\n  font-weight: bold;\n}\n.section-question .cite {\n  color: #0669f9;\n  font-weight: bold;\n}\n.section-question > div {\n  text-align: justify;\n}", ""]);

// exports
